import React from 'react';
import { useFormContext } from 'react-hook-form';

const VehicleCard = ({ index }) => {
    const { register, formState: { errors } } = useFormContext();
    const prefix = `vehicles.${index}`;
    const error = errors?.vehicles?.[index];

    return (
        <div className="grid grid-cols-6 gap-4 pr-8">
            <div className="col-span-6 sm:col-span-2">
                <label className="block text-xs font-medium text-gray-700">Year</label>
                <input
                    type="number"
                    {...register(`${prefix}.vehicle_year`, { valueAsNumber: true })}
                    className="mt-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                    placeholder="2023"
                />
            </div>

            <div className="col-span-6 sm:col-span-2">
                <label className="block text-xs font-medium text-gray-700">Make *</label>
                <input
                    type="text"
                    {...register(`${prefix}.vehicle_make`)}
                    className={`mt-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500 ${error?.vehicle_make ? 'border-red-300' : ''}`}
                    placeholder="Ford"
                />
                {error?.vehicle_make && <span className="text-xs text-red-500">{error.vehicle_make.message}</span>}
            </div>

            <div className="col-span-6 sm:col-span-2">
                <label className="block text-xs font-medium text-gray-700">Model *</label>
                <input
                    type="text"
                    {...register(`${prefix}.vehicle_model`)}
                    className={`mt-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500 ${error?.vehicle_model ? 'border-red-300' : ''}`}
                    placeholder="F-150"
                />
                {error?.vehicle_model && <span className="text-xs text-red-500">{error.vehicle_model.message}</span>}
            </div>

            <div className="col-span-6 sm:col-span-3">
                <label className="block text-xs font-medium text-gray-700">License Plate</label>
                <input
                    type="text"
                    {...register(`${prefix}.vehicle_license_plate`)}
                    className="mt-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                    placeholder="ABC-1234"
                />
            </div>

            <div className="col-span-6 sm:col-span-3">
                <label className="block text-xs font-medium text-gray-700">VIN</label>
                <input
                    type="text"
                    {...register(`${prefix}.vehicle_vin`)}
                    className="mt-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                    placeholder="1FT..."
                />
            </div>

            <div className="col-span-6 sm:col-span-3">
                <label className="block text-xs font-medium text-gray-700">State Registered</label>
                <input
                    type="text"
                    {...register(`${prefix}.vehicle_state_registered`)}
                    className="mt-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                    placeholder="TX"
                />
            </div>
            <div className="col-span-6 sm:col-span-3">
                <label className="block text-xs font-medium text-gray-700">Color</label>
                <input
                    type="text"
                    {...register(`${prefix}.vehicle_color`)}
                    className="mt-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Red"
                />
            </div>
        </div>
    );
};

export default VehicleCard;
